import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";

const baseUrl = "/api/sif/semeLibido";

export const getSeedLibidoTypes = createAsyncThunk(
  "seedLibido/getAll",
  async ({ filter }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        filter
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const thunks = [getSeedLibidoTypes];

const seedLibidoTypeSlice = createSlice({
  name: "seedLibido",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSeedLibidoTypes.fulfilled, (state, action) => {
      state.list = action.payload?.content || [];
    });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default seedLibidoTypeSlice.reducer;
